import role from './role';

export default function(spec) {
  return {
    clip:        spec.clip || false,
    interactive: spec.interactive === false ? false : true,
    marktype:    spec.type,
    name:        spec.name || undefined,
    role:        spec.role || role(spec),
    zindex:      +spec.zindex || undefined
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/marks/definition.js
// module id = 1447
// module chunks = 0